const en_trans_common = {
    dist_point: "distribution point",
    search_ref: "search reference",
    stock_remainning: "remaining stock",
    select_trans: "select transaction",
    req_id: "request ID",
    trans_id: "transaction ID",

    qty_po: "PO quantity",
    qty_so: "SO quantity",
    qty_ref: "reference quantity : {{qty}}",
    btn_cost: "add cost",
    btn_discount: "add discount",
    cost_added: "additional cost",
    cost_discount: "discount cost",

    pay: "pay",
    paid: "paid",
    // pay_deposit: 'pay the deposit',

    remaining: "remaining",
    inv_amount: "total invoice amount",
    inv_remainning: "remainning amount",
    total_payed: "total paid",

    rfq: "request for quotation",
    rfq_add: "create request for quotation",

    label: {
        ppn_used: "PPN applied",

        dp: "down payment (DP)",
        dp_nominal: "down payment amount",
        dp_pay: "pay down payment",

        inv_add: "add invoice",
        inv_del: "delete invoice",

        view_ppn: "view with PPN",
    },
}

export default en_trans_common;